/* eslint-disable operator-linebreak */
/* eslint-disable arrow-parens */
import Slider from 'javascripts/globals/slider';
import { BREAKPOINTS } from 'javascripts/constants';

const mql = [
  window.matchMedia(`(min-width: ${BREAKPOINTS.m})`),
  window.matchMedia(`(min-width: ${BREAKPOINTS.l})`),
];

let componentStore = [];

function onMediaQueryChange() {
  componentStore.forEach(
    component => component.deconstructor && component.deconstructor(),
  );
  componentStore = [];
  const isL = mql[1].matches;
  const isM = mql[0].matches;

  document.querySelectorAll('.teaser-slider').forEach($slider => {
    const $items = $slider.querySelectorAll('.teaser-slider__item');
    let disableSlider = $items && $items.length <= 2 && isL;

    // Inside a content-carousel there is only one item visible on L
    // so we need to adjust the condition here
    if ($slider.closest('.content-carousel')) {
      disableSlider =
        ($items && $items.length <= 1 && isL) ||
        ($items && $items.length <= 2 && isM && !isL);
    }
    if (disableSlider) {
      return;
    }

    componentStore.push(
      new Slider($slider, {
        rewind: true,
        sliderFrame: 'teaser-slider__block',
        slidesContainer: 'teaser-slider__items',
        sliderSlide: 'teaser-slider__item',
        sliderControlsframe: 'teaser-slider__controls',
        sliderControlsframemethod: 'append',
        slidesToScroll: 1,
        slidesFocusable: false,
      }),
    );
  });
}

mql.forEach(el => {
  el.addListener(onMediaQueryChange);
});

onMediaQueryChange();
